import React from 'react';

import postalCodeNormalizerGB from '../validate/postalCodeNormalizerGB';
import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsGB } from './addressValidation';
import addressFields from './addressFieldMessages';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';
import countyNameMap, {
    gbCountyField,
    gbCountyCodeMap
} from './data/GBCountyMap';


export const makeCountyList = () => {
    const counties = Object.keys(countyNameMap);
    const placeholder = {
        value: '',
        label: gbCountyField.countyLabel.defaultMessage
    };
    return [placeholder].concat(counties.map(code => ({
        value: gbCountyCodeMap[code],
        label: countyNameMap[code].defaultMessage
    })));
};

export const AddressFieldsGB = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.GB.street1Label,
        updateShippingAddress,
        useAddressAutocomplete: false, 
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.GB.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.GB.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.GB.stateLabel,
        options: makeCountyList(),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        label: addressFields.GB.postalCodeLabel,
        normalize: postalCodeNormalizerGB,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsGB.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsGB
};

AddressFieldsGB.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsGB;
